import React from "react";
import { useEffect } from "react";
import { useState } from "react";
import MobileHeader from "../../components/header/MobileHeader";
import LoginHeader from "../../components/header/LoginHeader";
import Footer from "../../components/footer";
import Gotop from "../../components/gotop";
import Breadcrumb from "../../components/breadcrumb"; 
import LoginMobileHeader from "../../components/header/LoginMobileHeader"; 
import CRMobileHeader from "../../components/header/CRMobileHeader";
import InstituteMobileHeader from "../../components/header/InstituteMobileHeader";
import InstituteHeader from "../../components/header/InstituteHeader";
import CRHeader from "../../components/header/CRHeader";
import NonLoginHeader from "../../components/header/NonLoginHeader"; 
import EditJobs from "./EditJobs";
import { Helmet } from "react-helmet";


function Editjob() {

    const [isShowMobile, setShowMobile] = useState(false);

    const handleMobile = () => {
        const getMobile = document.querySelector(".menu-mobile-popup");
        setShowMobile(!isShowMobile);
        !isShowMobile
            ? getMobile.classList.add("modal-menu--open")
            : getMobile.classList.remove("modal-menu--open");
    };

    useEffect(() => {
        const WOW = require("wowjs");
        window.wow = new WOW.WOW({
            live: false,
        });
        window.wow.init();
    }, []);
    const module = localStorage.getItem('Module')
    return (
        <>
         <Helmet>
				<title>Job/Update | Jobkikhoj</title>
				<meta name="description" content=" " />
				<meta name="keywords" content=" " />
				<meta property="og:title" content="Job/Update | Jobkikhoj " />
				<meta property="og:description" content="" />
				<meta property="og:url" content="https://jobkikhoj.com" />
			</Helmet>
            {module === 'Candidate' ? <LoginMobileHeader handleMobile={handleMobile} /> :
                module === 'Institution' ? <InstituteMobileHeader handleMobile={handleMobile} /> :
                    module === 'Company' ? <CRMobileHeader handleMobile={handleMobile} /> :
                        module === 'Recruiter' ? <CRMobileHeader handleMobile={handleMobile} /> :
                            <MobileHeader handleMobile={handleMobile} />}
            {module === 'Candidate' ? <LoginHeader clname="manageJobs" handleMobile={handleMobile} /> :
                module === 'Institution' ? <InstituteHeader clname="manageJobs" handleMobile={handleMobile} /> :
                    module === 'Company' ? <CRHeader   handleMobile={handleMobile} /> :
                        module === 'Recruiter' ? <CRHeader   handleMobile={handleMobile} /> :
                            <NonLoginHeader clname="manageJobs" handleMobile={handleMobile} />}
          

            <div className="pt-70 mb-5">
                <EditJobs />
            <Gotop />
            </div>
        </>
    );
}

export default Editjob;


// import React from 'react'

// const Editjob = () => {
//   return (
//     <div>Editjob</div>
//   )
// }

// export default Editjob